headline: "Ready to reclaim your <em>operational hours?</em>"
subtext: "Book a free 30-minute workflow audit. We'll identify exactly where AI creates real leverage for your team — no obligation, no jargon."

actions:
  - label: "Book a Discovery Call →"
    href: "#book"
    style: primary
  - label: "hello@banoffee.work"
    href: "mailto:hello@banoffee.work"
    style: ghost
